import React, { useState } from 'react';
import BASE_URL from '../utils/api';

// Horas reais dos responsáveis: são informadas só no FECHAMENTO (concluir tarefa, agendamento, garantia ou
// manutenção). Na criação vão só as horas previstas. Campo vazio = 0.
// responsaveis: [{ id, nome, horasPrevistas, horasReais }]
export default function PopupHorasReais({ titulo = 'Horas reais dos responsáveis', responsaveis = [], onConfirmar, onCancelar }) {
  const [horas, setHoras] = useState(() => {
    const inicial = {};
    responsaveis.forEach(r => {
      const atual = parseFloat(r.horasReais) || 0;
      inicial[r.id] = atual > 0 ? String(atual) : '';
    });
    return inicial;
  });

  const confirmar = () => {
    for (const r of responsaveis) {
      if ((parseFloat(horas[r.id]) || 0) < 0) {
        alert('As horas não podem ser negativas.');
        return;
      }
    }
    const resultado = {};
    responsaveis.forEach(r => { resultado[r.id] = parseFloat(horas[r.id]) || 0; });
    onConfirmar && onConfirmar(resultado);
  };

  const total = responsaveis.reduce((t, r) => t + (parseFloat(horas[r.id]) || 0), 0);
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 95090, padding: 16 }}>
      <div style={{ width: '100%', maxWidth: 520, maxHeight: '88vh', overflowY: 'auto', background: '#fff', borderRadius: 12, padding: 20, boxShadow: '0 8px 30px rgba(0,0,0,0.25)' }}>
        <h3 style={{ margin: '0 0 8px', color: 'rgb(235, 133, 0)' }}>{titulo}</h3>
        <p style={{ margin: '0 0 14px', color: '#444', fontSize: 13, lineHeight: 1.5 }}>
          Informe quantas horas cada responsável trabalhou de verdade. As horas reais só são lançadas agora, no fechamento.
        </p>
        {responsaveis.map(r => (
          <div key={r.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, padding: 10, border: '1px solid #eee', borderRadius: 8, marginBottom: 8 }}>
            <div style={{ minWidth: 0 }}>
              <div style={{ fontWeight: 700, fontSize: 14 }}>{r.nome || 'Responsável'}</div>
              <div style={{ fontSize: 12, color: '#777' }}>Previstas: {(parseFloat(r.horasPrevistas) || 0).toLocaleString('pt-BR', { maximumFractionDigits: 2 })}h</div>
            </div>
            <input
              type="number"
              min="0"
              step="0.5"
              placeholder="Hrs reais"
              value={horas[r.id] ?? ''}
              onChange={(e) => setHoras(prev => ({ ...prev, [r.id]: e.target.value }))}
              style={{ width: 110, padding: 8, borderRadius: 6, border: '1px solid #ddd', fontSize: 14 }}
            />
          </div>
        ))}
        <div style={{ textAlign: 'right', fontSize: 13, fontWeight: 700, color: '#2e7d32', margin: '4px 0 14px' }}>
          Total de horas reais: {total.toLocaleString('pt-BR', { maximumFractionDigits: 2 })}h
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
          <button type="button" className="btn-cancelar-forte" onClick={onCancelar} style={{ padding: '10px 18px', borderRadius: 6, border: 'none', cursor: 'pointer', fontWeight: 600 }}>Cancelar</button>
          <button type="button" onClick={confirmar} style={{ padding: '10px 18px', borderRadius: 6, border: 'none', cursor: 'pointer', fontWeight: 700, background: 'rgb(235, 133, 0)', color: '#fff' }}>Confirmar horas e salvar</button>
        </div>
      </div>
    </div>
  );
}

// Grava as horas reais de cada responsável ({ [responsavelId]: horas }) sem mexer nas previstas
export async function salvarHorasReais(horasPorResponsavel) {
  for (const [id, horasReais] of Object.entries(horasPorResponsavel || {})) {
    const resposta = await fetch(`${BASE_URL}/Responsaveis/${id}/horas`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ horasReais })
    });
    if (!resposta.ok) throw new Error(`não foi possível salvar as horas reais (responsável ${id})`);
  }
}
